<template>
  <div v-if="call !== null" class="call-info">
    <CallInfo :uid="uid"></CallInfo>
  </div>
</template>

<script>

import CallInfo from "~/components/partials/Call/CallInfo";
import {mapActions,mapGetters} from "vuex";

export default {
  name: "SpeechAnalysisCall",
  components: {
    CallInfo,
  },

  data() {
    return {
      uid: null,
    }
  },

  mounted() {
    this.uid = this.$route.params.uid;
    // const uid = this.$route.params.uid;
    // this.loadCall({uid: uid, query: {with: 'transcribe,audios,markers,meta'}});
  },

  computed: {
    ...mapGetters({
      call: 'reports/call',
    }),
  },

  methods: {
    ...mapActions({
      //loadCall: "reports/loadCall",
    }),
  }
}
</script>

<style scoped>
.call-info {
  padding-bottom: 70px;
}
</style>